import { UPDATE_CREDIT_USER, DELETE_CREDIT_USER, UPDATE_DATOS_VARIOS, UPDATE_DEUDA_HOY_BACKEND } from './types';


export function CreditUserReducer(state, action) {

    const { payload, type } = action


    switch (type) {

        case UPDATE_CREDIT_USER:
            return {
                ...state,
                creditUser: payload
            }

        case UPDATE_DATOS_VARIOS:

            return {
                ...state,
                datosVarios: payload
            }

        case DELETE_CREDIT_USER:

            return {
                ...state,
                creditUser: payload
            }
            
        case UPDATE_DEUDA_HOY_BACKEND:

            return {
                ...state,
                deudaHoyBackend: payload
            }
        default:
            break;
    }

} 